import React from "react";

import { addDays, startOfWeek } from "date-fns";

import CalendarTimeGrid from "../components/CalendarTimeGrid";

type Props = {
  focusedDate: Date;
};

const CalendarWeekView: React.FC<Props> = ({ focusedDate }) => {
  const weekStart = startOfWeek(focusedDate);
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));

  return <CalendarTimeGrid dates={days} />;
};

export default CalendarWeekView;
